<template>

    <div id="order-help-section" class="container-new right-info-block">
        <i class="ion-ios-information-outline"></i>
        <!-- step 1 -->
        <h2 v-show="step == 1">Punkt podjęcia</h2>
        <div v-show="step == 1" class="single-info">
            <h3>1</h3>
            <p>Wybierz salon podjęcia dostępny z widocznej obok listy, następnie przejdź dalej</p>
        </div>

        <!-- step 2 -->
        <h2 v-show="step == 2">Adres realizacji</h2>
        <div v-show="step == 2" class="single-info">
            <h3>1</h3>
            <p>Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.</p>
            <p>Przed przejściem dalej sprawdź poprawność danych.</p>
        </div>

        <h2 v-show="step == 3">Szczegóły</h2>
        <div class="single-info" v-show="step == 3">
            <h3>1</h3>
            <p>Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk "Dodaj". Krok ten jest niezbędny do obliczenia kosztów transportu.</p>
        </div>
        <div class="single-info" v-show="step == 3">
            <h3>2</h3>
            <p>W przypadku większej ilości zamówień dodaj kolejne zamówienia postepując zgodnie z pkt. 1.</p>
        </div>
        <div class="single-info" v-show="step == 3">
            <h3>3</h3>
            <p>Wybierz preferowaną datę realizacji spośród dostępnych terminów. W przypadku wyboru innego terminu realizacji, wybierz opcję "Inny termin", a następnie wpisz preferowany termin realizacji.</p>
            <p>UWAGA! Podane terminy są najbliższymi możliwymi</p>
        </div>
        <div class="single-info" v-show="step == 3">
            <h3>4</h3>
            <p>Wybierz preferowany przedział godzinowy dostawy.</p>
        </div>
        <div class="single-info" v-show="step == 3">
            <h3>5</h3>
            <p>Po uzupełnieniu wszystkich danych przejdź dalej do podsumowania.</p>
        </div>


        <h2 v-show="step == 4">Podsumowanie</h2>
        <div v-show="step == 4" class="simple-paragraph">
            <p>Prosimy o sprawdzenie poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia wraz z linkiem do płatności.</p>
            <p>Jeśli wszystkie wprowadzone przez Ciebie dane zgadzają się, możesz zakończyć proces rejestracji zamówienia dostawy. W przeciągu 5 minut otrzymasz potwierdzenie smsowe, a także mail z podsumowaniem zamówienia zawierający link do płatności online, dzięki któremu będziesz mógł dokonać opłaty za transport w wygodny dla siebie sposób.</p>
            <p>Dziękujemy za skorzystanie z usług DTS i życzymy miłego dnia!</p>
        </div>



    </div>
</template>

<script>
    export default {
        name: 'orderHelpSection',
        props: ["step"],
        data () {
            return {

            }
        }
    }
</script>




// WEBPACK FOOTER //
// HelpSection.vue?03ac0b19